import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import callAPI from '../call-api';
import { normalizePropertyPath } from '../utils/property-path';
import Form from './Form';
import LoadingOverlay from './LoadingOverlay';
import ThemedInput from './ThemedInput';

const NoteDiv = glamorous.div({
  display: 'block',
  paddingTop: 4,
  paddingBottom: '1rem',
  fontStyle: 'italic',
  fontSize: '1.2rem',
  color: '#585858',
  '& ul': {
    marginLeft: 18,
  },
});

const checkFieldsMatch = (fieldName, { matchMessage, matchField }) => (
  value,
  form
) => {
  return {
    value,
    error: value !== form[matchField] ? matchMessage : null,
  };
};

export default class PasswordForm extends React.Component {
  static propTypes = {
    username: PropTypes.string,
    passwordEndpoint: PropTypes.string.isRequired,
    onSuccess: PropTypes.func,
    onFailure: PropTypes.func,
  };
  static formInputs = [
    () => (
      <NoteDiv key="password-rules">
        Passwords must contain:
        <ul>
          <li>8 characters</li>
          <li>At least 1 uppercase letter</li>
          <li>At least 1 lowercase letter</li>
          <li>At least 1 number</li>
          <li>No spaces</li>
        </ul>
      </NoteDiv>
    ),
    {
      Component: ThemedInput,
      name: 'password',
      label: 'New Password',
      type: 'password',
      required: true,
    },
    {
      Component: ThemedInput,
      name: 'confirmPassword',
      label: 'Confirm New Password',
      type: 'password',
      required: true,
      onChange: checkFieldsMatch('confirmPassword', {
        matchField: 'password',
        matchMessage: 'Passwords must match.',
      }),
    },
  ];
  state = {
    isLoading: false,
    errors: { form: [] },
  };

  handleResetFailure = (json, onCompleteHandler, updateField) => {
    const validationErrors =
      json && json.detailedErrors
        ? json.detailedErrors.map(err => ({
            ...err,
            propertyName: normalizePropertyPath(err.propertyName),
          }))
        : [];
    onCompleteHandler(json.message, validationErrors);
    updateField({ fieldName: 'confirmPassword', value: '' });
    return this.setState(prevState => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        form: [json.message],
      },
    }));
  };

  handleSubmit = ({ form, updateField }, onCompleteHandler) => {
    const { password } = form;

    this.setState(prevState => ({
      ...prevState,
      isLoading: true,
    }));

    const requestBody =
      this.props.username && this.props.username.length
        ? {
            Username: this.props.username,
            Password: password,
          }
        : {
            Password: password,
          };

    callAPI(this.props.passwordEndpoint, {
      method: 'POST',
      body: JSON.stringify(requestBody),
    })
      .then(
        results => {
          const { resp, json } = results;
          this.setState(prevState => ({
            ...prevState,
            isLoading: false,
          }));
          //success, should get 204
          if (resp.ok && resp.status === 204) {
            this.props.onSuccess({ resp, json }, form);
          } else {
            this.props.onFailure({ resp, json }, form);
            return this.handleResetFailure(
              json,
              onCompleteHandler,
              updateField
            );
          }
        },
        ({ json, resp }) => {
          this.props.onFailure({ resp, json });
          return this.handleResetFailure(json, onCompleteHandler, updateField);
        }
      )
      .catch(() => {
        this.setState(prevState => ({
          ...prevState,
          isLoading: false,
        }));
      });
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    const { passwordEndpoint, onSuccess, onFailure, ...restProps } = this.props;
    return (
      <div>
        <Form
          initState={{}}
          formInputs={PasswordForm.formInputs}
          formSubmit={this.handleSubmit}
          formErrors={this.state.errors.form}
          {...restProps}
        />
        <LoadingOverlay isLoading={this.state.isLoading} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/PasswordForm.js